import React from 'react';
import PropTypes from 'prop-types';
import {StaticTableRowItem, GrowableTableRowItem, Line, InvoiceItemTableRow, NumberColumn} from './invoice-row.styled';

import {KebabMenuIcon} from '../../util-components/menus/kebab_menu_icon';
import {MeatballMenuIcon} from '../../util-components/menus/meatball_menu_icon';
import {Checkbox} from '../../util-components/checkbox/checkbox';

export const InvoiceRow = ({
	customProjectField,
	projectColumn,
	invoiceId,
	invoiceName,
	onInvoiceClick,
	amounts,
	onContextMenu,
	contextMenuElement,
	columns,
	cy,
	client,
	description,
	hasDescriptionError,
	quantity,
	unitPrice,
	tax,
	discount,
	totalPrice,
	status,
	name,
	date,
	dueDate,
	isSelected,
	onSelect,
	simpleDate,
	datePickerDate,
	notes,
	integrationLinks,
	isFirstRow,
	isEntryRow,
	isOverviewTab,
	isInvoicesTab,
	xeroAccount,
	quickbooksItem,
	economicProduct,
	sageIntacctLocation,
	sageIntacctAccount,
	customHeight,
	customWidth,
	showMeatballMenu,
	customHoverBackground,
}) => {
	return (
		<>
			<Line data-cy={cy}>
				<InvoiceItemTableRow
					onContextMenu={e => onContextMenu(e)}
					entryRow={isEntryRow}
					customHoverBackground={customHoverBackground}
				>
					{onSelect ? (
						<StaticTableRowItem alignLeft data-userpilot={'project-checkbox'}>
							<Checkbox checked={isSelected} onClick={onSelect} />{' '}
						</StaticTableRowItem>
					) : null}
					{columns.simpleDate && (
						<StaticTableRowItem alignLeft className={'date'}>
							{<NumberColumn>{simpleDate}</NumberColumn>}
						</StaticTableRowItem>
					)}
					{columns.datePicker && (
						<StaticTableRowItem alignLeft className={'datepicker'}>
							{<NumberColumn>{datePickerDate}</NumberColumn>}
						</StaticTableRowItem>
					)}
					{columns.project &&
						(customProjectField ? (
							customProjectField
						) : (
							<GrowableTableRowItem
								className={'project ' + (isEntryRow ? 'entry-row' : '')}
								customHeight={customHeight}
							>
								{projectColumn}
							</GrowableTableRowItem>
						))}
					{columns.name && <StaticTableRowItem className={'name'}>{<span>{name}</span>}</StaticTableRowItem>}
					{columns.notes && (
						<GrowableTableRowItem alignLeft className={'notes'}>
							{<NumberColumn>{notes}</NumberColumn>}
						</GrowableTableRowItem>
					)}
					{columns.invoiceId && (
						<StaticTableRowItem className={'invoiceId'} onClick={onInvoiceClick ? onInvoiceClick : null}>
							{<span>{invoiceId}</span>}
						</StaticTableRowItem>
					)}
					{columns.invoiceName && (
						<GrowableTableRowItem className={'invoiceName'} onClick={onInvoiceClick ? onInvoiceClick : null}>
							<span>{invoiceName}</span>
						</GrowableTableRowItem>
					)}
					{columns.client && (
						<GrowableTableRowItem className={'client'}>{<span>{client}</span>}</GrowableTableRowItem>
					)}
					{(columns.uninvoicedTimeRegMinutes || columns.uninvoicedRetainerMinutes) && (
						<StaticTableRowItem className={'hours'}>
							{<NumberColumn>{amounts.uninvoicedMinutes}</NumberColumn>}
						</StaticTableRowItem>
					)}
					{columns.uninvoicedPrice && (
						<StaticTableRowItem className={'price'}>
							{<NumberColumn>{amounts.uninvoicedPrice}</NumberColumn>}
						</StaticTableRowItem>
					)}
					{columns.uninvoicedFixedPrice && (
						<StaticTableRowItem className={'fixed-price'}>
							{<NumberColumn>{amounts.uninvoicedPrice}</NumberColumn>}
						</StaticTableRowItem>
					)}
					{columns.uninvoicedExpenses && (
						<StaticTableRowItem className={'price'}>
							{<NumberColumn>{amounts.uninvoicedExpenses}</NumberColumn>}
						</StaticTableRowItem>
					)}
					{columns.uninvoicedAmount && (
						<StaticTableRowItem className={'price'}>
							{<NumberColumn>{amounts.totalUninvoiced}</NumberColumn>}
						</StaticTableRowItem>
					)}
					{columns.overviewInvoicedAmount === true ? (
						<StaticTableRowItem className={'price'}>
							{<NumberColumn>{amounts.invoicedAmount}</NumberColumn>}
						</StaticTableRowItem>
					) : null}
					{columns.description && (
						<StaticTableRowItem
							className={'description' + (hasDescriptionError ? ' has-error' : '')}
							customHeight={customHeight}
							customWidth={customWidth}
						>
							{<span>{description}</span>}
						</StaticTableRowItem>
					)}
					{columns.xeroAccount && (
						<StaticTableRowItem className={'xero-account'} customHeight={customHeight}>
							{<span>{xeroAccount}</span>}
						</StaticTableRowItem>
					)}
					{columns.quickbooksItem && (
						<StaticTableRowItem className={'quickbooks-item'} customHeight={customHeight}>
							{<span>{quickbooksItem}</span>}
						</StaticTableRowItem>
					)}
					{columns.economicProduct && (
						<StaticTableRowItem className={'economic-product'} customHeight={customHeight}>
							{<span>{economicProduct}</span>}
						</StaticTableRowItem>
					)}
					{columns.sageIntacctAccount && (
						<StaticTableRowItem className={'sageIntacct-account'} customHeight={customHeight}>
							{<span>{sageIntacctAccount}</span>}
						</StaticTableRowItem>
					)}
					{columns.sageIntacctLocation && (
						<StaticTableRowItem className={'sageIntacct-location'} customHeight={customHeight}>
							{<span>{sageIntacctLocation}</span>}
						</StaticTableRowItem>
					)}
					{columns.quantity && (
						<StaticTableRowItem className={'quantity'} customHeight={customHeight}>
							{<NumberColumn>{quantity}</NumberColumn>}
						</StaticTableRowItem>
					)}
					{columns.unitPrice && (
						<StaticTableRowItem className={'price-input'} customHeight={customHeight}>
							{<NumberColumn>{unitPrice}</NumberColumn>}
						</StaticTableRowItem>
					)}
					{columns.discount && (
						<StaticTableRowItem className={'percentage'} customHeight={customHeight}>
							{<NumberColumn>{discount}</NumberColumn>}
						</StaticTableRowItem>
					)}
					{columns.tax && (
						<StaticTableRowItem className={'percentage'} customHeight={customHeight}>
							{<NumberColumn>{tax}</NumberColumn>}
						</StaticTableRowItem>
					)}
					{columns.totalPrice && (
						<StaticTableRowItem className={'totalPrice'} customHeight={customHeight}>
							{<NumberColumn>{totalPrice}</NumberColumn>}
						</StaticTableRowItem>
					)}
					{columns.status && <StaticTableRowItem className={'status'}>{<span>{status}</span>}</StaticTableRowItem>}
					{columns.date && <StaticTableRowItem className={'date'}>{<span>{date}</span>}</StaticTableRowItem>}
					{columns.invoicedAmount && (
						<StaticTableRowItem className={'price-small'}>
							{<NumberColumn>{amounts.invoicedAmount}</NumberColumn>}
						</StaticTableRowItem>
					)}
					{columns.paidAmount && (
						<StaticTableRowItem className={'price-small'}>
							{<NumberColumn>{amounts.paidAmount}</NumberColumn>}
						</StaticTableRowItem>
					)}
					{columns.paidInput && (
						<StaticTableRowItem className={'price-input'}>
							{<NumberColumn>{amounts.paidAmount}</NumberColumn>}
						</StaticTableRowItem>
					)}
					{columns.unpaidAmount && (
						<StaticTableRowItem className={'price-small'}>
							{<NumberColumn>{amounts.unpaidAmount}</NumberColumn>}
						</StaticTableRowItem>
					)}
					{columns.dueDate && <StaticTableRowItem className={'date'}>{<span>{dueDate}</span>}</StaticTableRowItem>}
					{columns.integrationLink && (
						<StaticTableRowItem className={'integration-links'}>{integrationLinks}</StaticTableRowItem>
					)}
					{columns.hasContextMenu && (
						<StaticTableRowItem
							customHeight={customHeight}
							width={showMeatballMenu !== true ? 20 : 30}
							className={'context-menu ' + (isEntryRow ? 'entry-row' : '')}
						>
							{showMeatballMenu !== true ? (
								<KebabMenuIcon
									onClick={e => onContextMenu(e)}
									cy={cy + '-context-menu'}
									userpilot={
										isFirstRow
											? 'context-menu-wrapper' +
											  (isOverviewTab ? '-overview' : isInvoicesTab ? '-invoices' : '')
											: null
									}
								></KebabMenuIcon>
							) : (
								<MeatballMenuIcon
									onClick={e => onContextMenu(e)}
									cy={cy + '-context-menu'}
									userpilot={
										isFirstRow
											? 'context-menu-wrapper' +
											  (isOverviewTab ? '-overview' : isInvoicesTab ? '-invoices' : '')
											: null
									}
								></MeatballMenuIcon>
							)}
						</StaticTableRowItem>
					)}
				</InvoiceItemTableRow>
			</Line>
			{contextMenuElement && contextMenuElement()}
		</>
	);
};

InvoiceRow.propTypes = {
	intl: PropTypes.shape({
		formatMessage: PropTypes.func,
	}),

	projectColumn: PropTypes.string,

	customProjectField: PropTypes.string,

	description: PropTypes.string,

	unitPrice: PropTypes.string,

	customHeight: PropTypes.number,

	customWidth: PropTypes.number,

	showMeatballMenu: PropTypes.bool,

	customHoverBackground: PropTypes.bool,

	tax: PropTypes.string,

	discount: PropTypes.string,

	totalPrice: PropTypes.string,

	quantity: PropTypes.string,

	invoiceId: PropTypes.string,

	invoiceName: PropTypes.string,

	onInvoiceClick: PropTypes.func,

	simpleDate: PropTypes.string,

	datePickerDate: PropTypes.string,

	notes: PropTypes.string,

	name: PropTypes.string,

	/**
	 * is project selected
	 */
	isSelected: PropTypes.bool,

	/**
	 * select callback
	 */
	onSelect: PropTypes.func,

	/**
	 * Client name
	 */
	client: PropTypes.string,

	/**
	 * Entry status dropdown
	 */
	status: PropTypes.element,

	/**
	 * Entry date
	 */
	date: PropTypes.string,

	/**
	 * Entry due date
	 */
	dueDate: PropTypes.string,

	/**
	 * paidAmount
	 */
	paidAmount: PropTypes.string,

	/**
	 * unpaidAmount
	 */
	unpaidAmount: PropTypes.string,

	/**
	 * Amounts of hours and prices
	 */
	amounts: PropTypes.object,

	/**
	 * Name of the project
	 */
	invoicedAmount: PropTypes.number,

	/**
	 * Name of the client attached to the project
	 */
	clientName: PropTypes.string,

	/**
	 * Currency of the company
	 */
	currency: PropTypes.string,

	/**
	 * Array of integration logos, or a string that says "Not exported"
	 */
	integrationLinks: PropTypes.arrayOf(PropTypes.any),

	/**
	 * Function to open the context menu
	 */
	onContextMenu: PropTypes.func,
	/**
	 * Context menu
	 */
	contextMenuElement: PropTypes.func,

	/**
	 * True if it*s the first row of the table
	 */
	isFirstRow: PropTypes.bool,

	/**
	 * True if it*s in the entries table
	 */
	isEntryRow: PropTypes.bool,

	/**
	 * True if description has an error
	 */
	hasDescriptionError: PropTypes.bool,

	/**
	 * True if it*s in the overview tab
	 */
	isOverviewTab: PropTypes.bool,

	/**
	 * True if it*s in the invoices tab
	 */
	isInvoicesTab: PropTypes.bool,

	/**
	 * True if it*s in a modal
	 */
	isInModal: PropTypes.bool,

	/**
	 * Xero Account dropdown
	 */
	xeroAccount: PropTypes.element,

	/**
	 * Quickbooks item dropdown
	 */
	quickbooksItem: PropTypes.element,

	/**
	 * E-conomic product dropdown
	 */
	economicProduct: PropTypes.element,

	/**
	 * Sage Intacct location dropdown
	 */
	sageIntacctLocation: PropTypes.element,

	/**
	 * Sage Intacct account dropdown
	 */
	sageIntacctAccount: PropTypes.element,

	/**
	 * Elements to show (or not) in the row
	 */
	columns: PropTypes.shape({
		project: PropTypes.bool,
		invoiceName: PropTypes.bool,
		invoiceId: PropTypes.bool,
		uninvoicedTimeRegMinutes: PropTypes.bool,
		uninvoicedRetainerMinutes: PropTypes.bool,
		uninvoicedPrice: PropTypes.bool,
		uninvoicedFixedPrice: PropTypes.bool,
		uninvoicedExpenses: PropTypes.bool,
		uninvoicedAmount: PropTypes.bool,
		overviewInvoicedAmount: PropTypes.bool,
		client: PropTypes.bool,
		status: PropTypes.bool,
		name: PropTypes.bool,
		date: PropTypes.bool,
		dueDate: PropTypes.bool,
		invoicedAmount: PropTypes.bool,
		paidAmount: PropTypes.bool,
		paidInput: PropTypes.bool,
		unpaidAmount: PropTypes.bool,
		description: PropTypes.bool,
		unitPrice: PropTypes.bool,
		tax: PropTypes.bool,
		discount: PropTypes.bool,
		totalPrice: PropTypes.bool,
		quantity: PropTypes.bool,
		simpleDate: PropTypes.bool,
		datePicker: PropTypes.bool,
		notes: PropTypes.bool,
		integrationLink: PropTypes.bool,
		hasContextMenu: PropTypes.bool,
		xeroAccount: PropTypes.bool,
		quickbooksItem: PropTypes.bool,
		economicProduct: PropTypes.bool,
		sageIntacctLocation: PropTypes.bool,
		sageIntacctAccount: PropTypes.bool,
	}).isRequired,

	/**
	 * Cypress data information
	 */
	cy: PropTypes.string,
};

InvoiceRow.defaultProps = {
	intl: {
		formatMessage: ({id}) => id,
	},
};
